export default __webpack_public_path__ + "static/reviews-video-antonia-df99034b14595fb53572eaabb1ccb459.png";